import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-qitech-device-scan',
  template: '',
})
export class QITechDeviceScanComponent extends ComponentBase implements OnInit {
  private deviceScanScriptUrl: string = 'https://ds.viewpkg.com/device-scan-1-1-1.js';

  constructor() {
    super()
  }

  ngOnInit(): void {
    this.loadRemoteScript()
      .then(() => this.initializeDeviceScan())
      .catch((error) => console.error('Error loading Device Scan script:', error));
  }

  private loadRemoteScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = this.deviceScanScriptUrl;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Failed to load the Device Scan script.'));
      document.body.appendChild(script);
    });
  }

  private initializeDeviceScan(): void {
    const vPkg = window['vPkg'];
    const tokenAttr = this.attribute.attributes
      .find(attr => attr.key.toLowerCase() == "token");

    if (vPkg && vPkg.DeviceScan && tokenAttr) {
      const deviceScan = new vPkg.DeviceScan(tokenAttr.value, this.process.id ?? this.process.policyId).setSandbox();
      const eventTypeOpt = this.attribute.options.find(opt => opt.key.toLowerCase() == "event type");

      if (environment.name.toLowerCase() == "sandbox") {
        deviceScan.setSandbox();
      }

      deviceScan
        .info(eventTypeOpt?.value ?? 'default', this.process.policyId)
        .then((res: any) => {
          const resultAttr = this.attribute.attributes
            .find(attr => attr.key.toLowerCase() == "result");

          if (resultAttr) {
            resultAttr.value = JSON.stringify(res);
          }
        })
        .catch((error: any) => console.error('Device Scan Error:', error));
    } else {
      console.error('vPkg.DeviceScan is not available.');
    }
  }
}